<script>
  import { createEventDispatcher } from "svelte";
  import Section from "./Section.svelte";

  export let brand;
  export let active;
  export let mode;
  export let mbox;

  const dispatch = createEventDispatcher();
  function activate() {
    dispatch('message', {key: brand.key});
    mbox.getGalleries();
    mbox.init();
    let most = document.querySelectorAll('.mbox');
    console.log(most);
    console.log(mbox);
  }

</script>
<section key="{brand.key}" class={`brand ${active ? "is-active" : ""} ${mode ? "" : "is-hidden"}`}>
  <header>
    <img class="logo"
         alt={`${brand.key} logo`}
         src={`./images/logo--${brand.key}.svg`}
         on:click={activate}
    />
    <img
      class="banner"
      alt={`${brand.key} header`}
      srcset={`
               ./images/banner--${brand.key}-320.jpg 320w,
               ./images/banner--${brand.key}-640.jpg 640w,
               ./images/banner--${brand.key}-750.jpg 750w,
               ./images/banner--${brand.key}-1024.jpg 1024w,
               ./images/banner--${brand.key}-2048.jpg 2048w,
               `}
      src={`./images/banner--${brand.key}-320.jpg`}
    />
  </header>
  <main>
    <div class="description">
      {brand.description}
    </div>
    {#each brand.sections as section}
      <Section section={section} gallery={brand.key} />
    {/each}
  </main>
</section>
<style>
  .brand {
    display: block;
  }
  .logo {
    display: block;
    width: 100%;
    max-width: 60vh;
    margin: 0 auto;
    cursor: pointer;
  }
  @media screen and (orientation: landscape) {
    .logo {
      width: 33.333vw;
      max-height: 100vh;
      margin: 0 auto;
    }
  }
  .banner {
    width: 100%;
    max-width: 100%;
    display: none;
  }
  main {
    display: none;
    background-color: white;
    color: black;
  }
  .description {
    font-family: "Open Sans", sans-serif;
    max-width: 960px;
    padding: 40px 20px 0;
    margin: 0 auto 40px;
  }
  .is-active .banner {
    display: block;
  }
  .is-active main {
    display: block;
  }
  .is-hidden:not(.is-active) .logo {
    display: none;
  }


  @media screen and (orientation: landscape) and (min-width: 1400px) {
    .is-active {
      width: 100%;
      min-height: 100vh;
      display: flex;
      flex-direction: row;
      min-height: 0;
    }
    .brand.is-active {
      min-height: 0;
    }
    .is-active .logo {
      background-color: #003da6;
      width: 100%;
      max-width: 100%;
      max-height: 340px;
      cursor: default;
    }
    .is-active header {
      max-width: 1000px;
      flex-grow: 0;
      flex-shrink: 1;
      background-color: #18bcdf;
    }
    .is-active main {
      flex-grow: 1;
    }
    .description {
      padding: 120px 20px 0;
      font-size: 150%;
      line-height: 150%;
    }
  }
</style>
